import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const RegeneratePasswordForm_RegenerateUserPassword_Mutation = graphql(`
  mutation RegeneratePasswordForm_RegenerateUserPassword($userId: Id!) {
    regenerateUserPassword(userId: $userId)
  }
`);

export const useRegeneratePasswordMutation = () =>
  useGraphQLMutation(RegeneratePasswordForm_RegenerateUserPassword_Mutation);
